'use strict';

const { isEmpty } = require('lodash');
const capencyVerifyEmail = require('capency/capency/email/capency.verify.email');
const capencyHelper = require('capency/capencyHelper');
const capencyVerfiyAddress = require('capency/capency/address/capency.verify');

/**
 *
 * @param {string} languages available languages
 */
function setLanguagesSelectList(languages) {
    var languagesList = languages.split(',');
    var select = '<select class="form-control checkout-select pl-4">';
    languagesList.forEach(function (lang) {
        select += '<option value="' + lang + '">' + lang + '</option>';
    });
    select += '</select>';
    $('.newsletterLanguages').html(select);
    $('.smsLanguages').html(select);
}
/**
 * Removes languages from DOM
 */
function unsetLanguagesSelectList() {
    $('.newsletterLanguages').empty();
    $('.smsLanguages').empty();
}

/**
* Submits validation for customer registration
* @param {function} submitAccount - function to submit the account registration form
*/
async function submitValidation(submitAccount) {
    $('.submit-customer-register').on('click', async function (e) {
        e.preventDefault();
        try {
            if (capencyHelper.isCapencyEnabled('phone')) {
                if (!capencyHelper.validatePhone()) return;
            }

            let $emailSelector = $('.registration input[name$="dwfrm_profile_customer_email"]');
            if (capencyHelper.isCapencyEnabled('email')) {
                await capencyVerifyEmail.checkEmailPropertyResult($emailSelector, false, 'registration');
            }

            let addressVerification = true;
            if (capencyHelper.isCapencyEnabled('address') && capencyHelper.isAddressFormModified()) {
                let result = await capencyVerfiyAddress.capencySearchAddress();
                addressVerification = await capencyVerfiyAddress.handleAddressVerification(result);
            }

            if (addressVerification) {
                submitAccount();
            } else {
                console.warn('Address verification failed.');
            }
        } catch (error) {
            console.error('Error during address verification:', error);
        }
    });
}

/**
 * Closes the dropdown within the given scope.
 * @param {jQuery} $scope - The container jQuery object.
 * @param {string} triggerSelector - Selector of the trigger button inside $scope.
 * @returns {void}
 */
function closeDropdown($scope, triggerSelector) {
    $scope.find('.dropdown-menu').hide();
    $scope.find(triggerSelector).attr('aria-expanded', 'false');
}

/**
 * Closes all country dropdowns found inside the given container.
 *
 * @param {jQuery} $container - Container to search within (modal, document, form, etc.)
 * @param {string} containerSelector - Selector for the dropdown root elements (e.g. '.account-country-selector')
 * @param {string} triggerSelector - Selector of the trigger button inside each root element
 * @returns {void}
 */
function closeAllDropdowns($container, containerSelector, triggerSelector) {
    $container.find(containerSelector).each(function () {
        closeDropdown($(this), triggerSelector);
    });
}

/**
 * Toggles the dropdown within the given scope,
 * closing all other instances of the same component first.
 * @param {jQuery} $scope - The container jQuery object.
 * @param {string} containerSelector - Global selector for all instances of this component.
 * @param {string} triggerSelector - Selector of the trigger button inside $scope.
 * @returns {void}
 */
function toggleDropdown($scope, containerSelector, triggerSelector) {
    const $menu = $scope.find('.dropdown-menu');
    const isOpen = $menu.is(':visible');

    $(containerSelector).not($scope).each(function () {
        closeDropdown($(this), triggerSelector);
    });

    if (isOpen) {
        closeDropdown($scope, triggerSelector);
    } else {
        $menu.show();
        $scope.find(triggerSelector).attr('aria-expanded', 'true');
    }
}

/**
* Handles the country selection in the account registration page
* @param {string} [hiddenSelector='#country'] - the hidden selector for the country code
*/
function handleCountrySelection(hiddenSelector = '#country') {
    const COUNTRY_CONTAINER = '.account-country-selector';
    const COUNTRY_TRIGGER = '.js-dropdownCountrySelector';

    $(document).ready(function () {
        const languageOption = $('.account-country-selector .dropdown-country-selector [data-languages]');
        const selectedCountry = $('input#country');

        let languages = languageOption.data('languages');
        let languageOptionId = languageOption.data('id');

        if (selectedCountry[0].value.toLowerCase() === 'be'
            && languageOptionId === 'be'
            && languages
        ) {
            setLanguagesSelectList(languages);
        }
    });

    $('body')
        .off('click.countrySelector', COUNTRY_CONTAINER)
        .on('click.countrySelector', COUNTRY_CONTAINER, function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $scope = $(this).closest(COUNTRY_CONTAINER);
            toggleDropdown($scope, COUNTRY_CONTAINER, COUNTRY_TRIGGER);
        });

    $(document)
        .off('.countrySelector')
        .on('click', function (e) {
            const $target = $(e.target);
            if ($target.closest(COUNTRY_CONTAINER).length === 0) {
                $(COUNTRY_CONTAINER).each(function () {
                    closeDropdown($(this), COUNTRY_TRIGGER);
                });
            }
        });

    // Prevent clicks inside the menu from bubbling up and closing it
    $('body')
        .off('click.countrySelectorMenu', '.account-country-selector .dropdown-menu')
        .on('click.countrySelectorMenu', '.account-country-selector .dropdown-menu', function (e) {
            e.stopPropagation();
        });

    // Generic: any Bootstrap modal closing anywhere on the page
    $(document)
        .off('hidden.bs.modal.countrySelector')
        .on('hidden.bs.modal.countrySelector', function (e) {
            // e.target is the modal element that was just hidden
            closeAllDropdowns($(e.target), COUNTRY_CONTAINER, COUNTRY_TRIGGER);
        });

    $('body')
        .off('click.countrySelectorItem', '.account-country-selector .dropdown-item')
        .on('click', '.account-country-selector .dropdown-item', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();

            const $this = $(this);
            const languages = $this.data('languages');

            const countryCode = !isEmpty($this.data('id'))
                ? $this.data('id').toUpperCase()
                : $this.data('id');

            const form = $this.parents('form');
            form.find(hiddenSelector).val(countryCode);

            $this.parent().siblings(COUNTRY_TRIGGER)
                .html($this.html())
                .find('.icon-pictoToteBag')
                .remove();

            if (!form.find('.address-form-phone').val()) {
                var phoneCode = $this.data('phonecode');
                form.find('.dropdown-phone-country-selector [data-phone-code="' + phoneCode + '"]').trigger('click');
            }

            if (languages) {
                setLanguagesSelectList(languages);
            } else {
                unsetLanguagesSelectList();
            }

            closeDropdown($this.closest(COUNTRY_CONTAINER), COUNTRY_TRIGGER);
        });
}

/**
 * Update phone number input with phone regex pattern
 */
function updatePhoneNumberInputPattern() {
    const $this = $(this);
    const pattern = $this.find('option:selected').data('pattern');

    const phoneInputID = getPhoneInputID($this);

    // Only applicable when in the account registration page
    if (isEmpty(pattern)) {
        $(phoneInputID).removeAttr('pattern');
    } else {
        $(phoneInputID).attr('pattern', pattern);
    }
}

/**
 * Set the phone number pattern on each phone number country change and on load
 */
function setPhoneNumberPattern() {
    $(document).ready(function () {
        updatePhoneNumberInputPattern.call($('#phoneCode'));
    });
    $('body').on('change', '#phoneCode', function () {
        updatePhoneNumberInputPattern.call(this);
    });
}

/**
 * Gets Phone Number input ID
 * @param {jQuery} $option select option element
 * @returns {string} phonenumber input ID in account registration form
 */
function getPhoneInputID($option) {
    let phoneInputID = '';
    const phoneInputID1 = '#registrationformphone';
    const phoneInputID2 = '#registration-form-phone';
    const phoneInputID3 = '#bookAddressPhone';
    const $phoneFormContainer = $option.closest('.phone-number-form-section');

    if ($phoneFormContainer.find(phoneInputID1).length) {
        phoneInputID = phoneInputID1;
    }
    if ($phoneFormContainer.find(phoneInputID2).length) {
        phoneInputID = phoneInputID2;
    }
    if ($phoneFormContainer.find(phoneInputID3).length) {
        phoneInputID = phoneInputID3;
    }

    return phoneInputID;
}

/**
 * Remove previous attribute checked state and reassign it to the current DOM input
 */
function setRadioOnChange() {
    $('body').on('click', 'input[type="radio"]', function () {
        var $this = $(this);
        var name = $this.attr('name');
        $('[name="' + name + '"]').removeAttr('checked');
        $this.prop('checked', 'checked');
    });
}

/**
* Handles the phone country selection in the account registration page
* @param {string} [hiddenSelector='#phoneCode'] - the hidden selector for the country code
*/
function handlePhoneCountrySelection(hiddenSelector = '#phoneCode') {
    const PHONE_CONTAINER = '.account-phone-country-selector';
    const PHONE_TRIGGER = '.js-dropdownPhoneCountrySelector';

    $('body')
        .off('click.phoneSelector', PHONE_CONTAINER)
        .on('click.phoneSelector', PHONE_CONTAINER, function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown($(this).closest(PHONE_CONTAINER), PHONE_CONTAINER, PHONE_TRIGGER);
        });

    // Prevent clicks inside the menu from bubbling up and closing it
    $('body')
        .off('click.phoneSelectorMenu', `${PHONE_CONTAINER} .dropdown-menu`)
        .on('click.phoneSelectorMenu', `${PHONE_CONTAINER} .dropdown-menu`, function (e) {
            e.stopPropagation();
        });

    $(document)
        .off('click.phoneSelector')
        .on('click.phoneSelector', function (e) {
            if (!$(e.target).closest(PHONE_CONTAINER).length) {
                $(PHONE_CONTAINER).each(function () {
                    closeDropdown($(this), PHONE_TRIGGER);
                });
            }
        });

    $(document)
        .off('hidden.bs.modal.phoneSelector')
        .on('hidden.bs.modal.phoneSelector', function (e) {
            $(e.target).find(PHONE_CONTAINER).each(function () {
                closeDropdown($(this), PHONE_TRIGGER);
            });
        });

    $('body')
        .off('click.phoneSelectorItem', '.account-phone-country-selector .dropdown-item')
        .on('click.phoneSelectorItem', '.account-phone-country-selector .dropdown-item', function (evt) {
            evt.preventDefault();
            let $this = $(this);
            let $form = $this.closest('form');
            let $phoneCodeField = $(hiddenSelector, $form);
            let $countryData = $this.find('i').data();
            const $phoneBlock = $('.phone-number-block', $form);
            let $phoneInput = null;

            Object.keys(forms).forEach(key => {
                let formId = forms[key].id;
                if ($phoneBlock.find(formId).length) {
                    $phoneInput = $phoneBlock.find(formId);
                    return false;
                }
                return true;
            });
            const $phonePrefixField = $phoneBlock.find('.phone-prefix-field');
            let phoneCode = !isEmpty($countryData) ? $countryData.phoneCode : '';
            let $phoneCountrySelector = $this.parent().siblings(PHONE_TRIGGER);
            $phoneCodeField.val(phoneCode);
            $phoneCodeField.data('countryCode', $countryData.countrycode);
            $phoneCountrySelector.html($this.html());
            $phonePrefixField.text(phoneCode);
            capencyHelper.removeFieldValidationResults($phoneInput);
            $phoneInput.trigger('change');

            closeDropdown($this.closest(PHONE_CONTAINER), PHONE_TRIGGER);
        });
}

let forms = {
    addressBook: {
        id: '#bookAddressPhone'
    },
    register: {
        id: '#phone'
    },
    checkoutShipping: {
        id: '.shippingPhoneNumber'
    },
    editAddressForm: {
        id: '#shippingPhoneNumber'
    },
    dwfrm_address: {
        id: 'shippingPhoneNumberdefault'
    },
    dwfrm_profilePhone: {
        id: '#newPhone'
    }
};

module.exports = {
    helpers: {
        submitValidation: submitValidation,
        handleCountrySelection: handleCountrySelection,
        handlePhoneCountrySelection: handlePhoneCountrySelection,
        setPhoneNumberPattern: setPhoneNumberPattern,
        setRadioOnChange: setRadioOnChange
    }
};
